import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const useWithOldPortalRedirect = () => {
  const { search } = useLocation()
  const { replace } = useHistory()
  const params = new URLSearchParams(search)

  useEffect(() => {
    const requestUrl = params.get('requestUrl')

    if (!requestUrl || requestUrl === '') return

    doRedirect(requestUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params])

  const doRedirect = (requestUrl: string) => {
    const url = mapToUrl(requestUrl)
    replace(url)
  }

  const mapToUrl = (requestUrl: string) => {
    const chunks = requestUrl.split('/')
    const area: string = `${chunks[1]}/${chunks[2]}`.toLocaleLowerCase()

    const newRoute = urlKeyPairs[area]

    const param = requestUrl.toLocaleLowerCase().replace('/' + area, '')

    if (!param || param === '') return newRoute

    if (isBlacklistParam(param)) return newRoute

    return newRoute + '?path=' + param
  }

  const isBlacklistParam = (param: string) => {
    return param === '/tab/publisert'
  }

  const urlKeyPairs: Record<string, string> = {
    'styreokonomi/ordreregistrering': 'okonomi/ordreregistering',
    'styreokonomi/budsjett': 'okonomi/budsjett',
    'styreokonomi/utbetaling': 'okonomi/godtgjorelse',
    'styreokonomi/utlegg': 'okonomi/utlegg',

    'styrerom/moete': 'styrearbeid/moter',
    'styrerom/fremdriftsplan': 'styrearbeid/fremdriftsplan',
    'styrerom/generalforsamling': 'styrearbeid/generalforsamling',
    'styrerom/generalforsamling/innmeldte-saker':
      'styrearbeid/generalforsamling/innmeldte-saker',
    'styrerom/fremmoete': 'styrearbeid/fremmoeteliste',
    'styrerom/aarshjul': 'styrearbeid/aarshjul',
    'styrerom/signeringer': 'styrearbeid/signeringer',
    'styrerom/avtaler': 'styrearbeid/avtaler',
    'dokument/indexstyre': 'styrearbeid/dokumenter',
    'dokument/arkiv': 'styrearbeid/dokumenter',
    'styrerom/styretsdokumenter': 'styrearbeid/dokumenter/styrets-dokumenter',

    'styrerom/rapporter': 'styrearbeid/boligselskapet',
    'infofrabbl/publiseringerstyre': 'boligbyggelaget/nyheter',
    'infofrabbl/historikkstyre': 'boligbyggelaget/nyheter/historiske-nyheter',
  }
}
export default useWithOldPortalRedirect
